import React from 'react';
import useQuotationSWR from '../../hooks/quotations/useQuotationSWR';
import { QuotationEditorWrapper } from './QuotationEditorWrapper';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';
import { ErrorTypography } from '../styled/ErrorTypography';

export const QuotationEditorContent = (props) => {
    const { quoteId } = props;

    const { quote, isLoading, isError, forceRefresh } =
        useQuotationSWR(quoteId);

    return (
        <>
            {isError && <ErrorTypography errorCode={'GLOBAL_ERROR'} />}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && quote && (
                <QuotationEditorWrapper
                    quote={quote}
                    refetch={forceRefresh}
                ></QuotationEditorWrapper>
            )}
        </>
    );
};
